/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-shadow */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api';
import polyline from '@mapbox/polyline';

const BookingMaps = ({ pickup, dropOff, encodedpolyline }) => {
	const [path, setPath] = useState([]);
	const [center, setCenter] = useState({
		lat: 37.17130611530913,
		lng: 9.772111191511911,
	});
	const mapRef = useRef(null);
	useEffect(() => {
		setCenter(generateCenterFromPickupAndDropOff());
	}, [pickup, dropOff]);

	const generateCenterFromPickupAndDropOff = () => {
		const lat = (pickup?.latitude + dropOff?.latitude) / 2;
		const lng = (pickup?.longitude + dropOff?.longitude) / 2;
		return { lat, lng };
	};

	useEffect(() => {
		if (!encodedpolyline) return;
		const decoded = polyline.decode(encodedpolyline);
		const path = decoded.map(([lat, lng]) => ({ lat, lng }));
		setPath(path.length === 1 ? [path[0], path[0]] : path);
	}, [encodedpolyline]);

	useEffect(() => {
		if (path.length === 0 || !mapRef.current) return;

		const bounds = new window.google.maps.LatLngBounds();

		path.forEach((point) => bounds.extend(point));

		mapRef.current.fitBounds(bounds);
	}, [path]);

	const onLoad = (map) => {
		mapRef.current = map;
	};

	return (
		<GoogleMap
			id='circle-example'
			mapContainerStyle={{
				borderRadius: '16px',
				height: '450px',
				width: '99%',
			}}
			onLoad={onLoad}
			center={center}
			zoom={7}
			options={{
				disableDefaultUI: true,
				zoomControl: true,
			}}>
			{path.length > 0 && (
				<>
					<Polyline
						path={path}
						options={{
							strokeColor: '#2979FF',
							strokeOpacity: 1,
							strokeWeight: 5,
						}}
					/>

					<Marker position={path[0]} label='A' />

					<Marker position={path[path.length - 1]} label='B' />
				</>
			)}
		</GoogleMap>
	);
};

export default BookingMaps;
